// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-container {
  width: 100%;
  position: absolute;
  bottom: 12px;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  min-height: 40px;
}
.bottom-container .minimal-card {
  background-color: var(--background);
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  overflow: hidden;
  border-radius: 8px;
}
.bottom-container .minimal-card .card-close {
  position: absolute;
  top: 8px;
  left: 20px;
  background-color: rgba(1, 1, 1, 0.6);
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.bottom-container .minimal-card .card-close ion-icon {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  margin: auto;
  color: white;
}
.bottom-container .minimal-card .card-cover {
  width: 33%;
  background-size: cover;
  background-position: center;
}
.bottom-container .minimal-card .card-content {
  padding: 12px 12px;
  width: 67%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.bottom-container .minimal-card .card-content .card-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.bottom-container .minimal-card .card-content .card-content-header .card-content-header-buttons {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.bottom-container .minimal-card .card-content .card-content-header .card-content-header-buttons ion-icon {
  font-size: 20px;
  padding: 8px;
}
.bottom-container .minimal-card .card-content .card-content-footer {
  align-items: flex-start;
  font-size: 16px;
  margin-top: 36px;
}
.bottom-container .minimal-card .card-content .card-content-footer .arrivedTime {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bottom-container .minimal-card .card-content .card-content-footer .arrivedTime .labelForToday > span {
  text-transform: capitalize;
}
.bottom-container .minimal-card .card-content .card-content-footer .arrivedTime > h5 {
  line-height: 10px;
  padding-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mirador-map-card-album/mirador-map-card-album.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,aAAA;EAEA,sBAAA;EACA,gBAAA;AACJ;AACI;EACI,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AACR;AACQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACZ;AACY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAChB;AAGQ;EACI,UAAA;EACA,sBAAA;EACA,2BAAA;AADZ;AAIQ;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFZ;AAIY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAFhB;AAIgB;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AAFpB;AAIoB;EACI,eAAA;EACA,YAAA;AAFxB;AAQY;EACI,uBAAA;EACA,eAAA;EACA,gBAAA;AANhB;AAQgB;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AANpB;AAQoB;EACI,0BAAA;AANxB;AASoB;EACI,iBAAA;EACA,gBAAA;AAPxB","sourcesContent":[".bottom-container {\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: 12px;\r\n    padding: 0 12px;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    -webkit-flex-direction: column;\r\n    flex-direction: column;\r\n    min-height: 40px;\r\n\r\n    .minimal-card {\r\n        background-color: var(--background);\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: space-around;\r\n        overflow: hidden;\r\n        border-radius: 8px;\r\n\r\n        .card-close {\r\n            position: absolute;\r\n            top: 8px;\r\n            left: 20px;\r\n            background-color: rgba(1, 1, 1, 0.6);\r\n            border-radius: 50%;\r\n            width: 30px;\r\n            height: 30px;\r\n\r\n            ion-icon {\r\n                position: absolute;\r\n                top: 0px;\r\n                left: 0px;\r\n                bottom: 0px;\r\n                right: 0px;\r\n                margin: auto;\r\n                color: white;\r\n            }\r\n        }\r\n\r\n        .card-cover {\r\n            width: 33%;\r\n            background-size: cover;\r\n            background-position: center;\r\n        }\r\n\r\n        .card-content {\r\n            padding: 12px 12px;\r\n            width: 67%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: space-between;\r\n\r\n            .card-content-header {\r\n                display: flex;\r\n                flex-direction: row;\r\n                justify-content: space-between;\r\n\r\n                .card-content-header-buttons {\r\n                    display: flex;\r\n                    flex-direction: row;\r\n                    justify-content: end;\r\n\r\n                    ion-icon {\r\n                        font-size: 20px;\r\n                        padding: 8px;\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .card-content-footer {\r\n                align-items: flex-start;\r\n                font-size: 16px;\r\n                margin-top: 36px;\r\n\r\n                .arrivedTime {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    overflow: hidden;\r\n                    white-space: nowrap;\r\n                    text-overflow: ellipsis;\r\n\r\n                    .labelForToday>span {\r\n                        text-transform: capitalize;\r\n                    }\r\n\r\n                    &>h5 {\r\n                        line-height: 10px;\r\n                        padding-top: 8px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
